__turbopack_context__.v({
  "control": "error-module__myAHIW__control",
  "image": "error-module__myAHIW__image",
  "root": "error-module__myAHIW__root",
  "text": "error-module__myAHIW__text",
  "textImage": "error-module__myAHIW__textImage",
  "title": "error-module__myAHIW__title",
});
